import React, { useEffect, useState } from 'react';
import { useAmp } from 'next/amp';
import Container from '../../atoms/Container';
import Styles from './Menu.css';

function Menu({ importPrefix }) {
  const isAmp = useAmp();
  const [open, setOpen] = useState(null);
  const [enableDismiss, setEnableDismiss] = useState(false);

  const getDialogClass = (index) => {
    if (isAmp) return 'menu-content';
    const state = open === index ? 'opened' : 'closed';
    return `menu-content ${state}`;
  };

  const updateOpenState = (index) => {
    if (index === open) setOpen(null);
    else setOpen(index);
  };

  useEffect(() => {
    const val = parseInt(open, 10);
    setEnableDismiss(!isNaN(val));
  }, [open]);

  const MenuContent = (
    <nav>
      <Container type="ul">
        <li>
          <span
            role="button"
            onClick={(ev) => {
              ev.preventDefault();
              updateOpenState(0);
            }}
          >
            Meu financiamento
          </span>
          <div role="dialog" className={getDialogClass(0)} aria-label="Menu meu dia a dia">
            <Container className="content-container">
              <div className="menu-col">
                <p>Boletos</p>
                <div>
                  <a href={`${importPrefix}boleto.html`} id="segunda-via-de-boletos-menu-desktop">
                    2ª via de boletos
                  </a>
                </div>
                <div>
                  <a
                    href={`${importPrefix}renegociacao-santander-financiamentos.html`}
                    id="renegociacao-menu-desktop"
                  >
                    Renegociação
                  </a>
                </div>
                <div>
                  <a
                    href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF"
                    target="_blank"
                    rel="noopener"
                    id="boleto-vencido-menu-desktop"
                  >
                    Boleto vencido
                  </a>
                </div>
                <div>
                  <a
                    href="https://santanderfinanciamentos.com.br/portalcliente/login?int_source=portalSF&int_medium=home:menu-meu-dia-a-dia&int_campaign=comprovantes"
                    target="_blank"
                    rel="noopener"
                    id="comprovantes-menu-desktop"
                  >
                    Comprovantes
                  </a>
                </div>
              </div>

              <div className="menu-col">
                <p>Soluções</p>
                <div>
                  <a
                    href={`${importPrefix}consultar-financiamento.html`}
                    id="consultar-financiamento-menu-desktop"
                  >
                    Consultar financiamento
                  </a>
                </div>
              </div>

              <div className="menu-col">
                <p>Contratos</p>
                <div>
                  <a
                    href="https://santanderfinanciamentos.com.br/portalcliente/login?int_source=portalSF&int_medium=home:menu-meu-dia-a-dia&int_campaign=resumo-copia-de-contrato"
                    target="_blank"
                    rel="noopener"
                    id="resumo-e-ou-copia-de-contrato-menu-desktop"
                  >
                    Resumo e/ou cópia de contrato
                  </a>
                </div>
                <div>
                  <a
                    href="https://santanderfinanciamentos.com.br/portalcliente/login?int_source=portalSF&int_medium=home:menu-meu-dia-a-dia&int_campaign=transferencia-de-financiamento"
                    target="_blank"
                    rel="noopener"
                    id="tranferencia-de-financiamento-menu-desktop"
                  >
                    Transferência de financiamento
                  </a>
                </div>
              </div>
            </Container>
          </div>
        </li>
        <li>
          <span
            role="button"
            onClick={(ev) => {
              ev.preventDefault();
              updateOpenState(1);
            }}
          >
            Produtos
          </span>
          <div role="dialog" className={getDialogClass(1)} aria-label="Menu produtos">
            <Container className="content-container">
              <div className="menu-col">
                <p>Produtos</p>
                <div>
                  <a
                    href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?ori=SF&int_source=menu-simule-ja#/simulacao"
                    target="_blank"
                    rel="noopener"
                    id="simular-financiamento-menu-desktop"
                  >
                    Simular Financiamento
                  </a>
                </div>
                <div>
                  <a
                    href={`${importPrefix}banco-do-auto.html`}
                    id="financiamento-de-veiculos-menu-desktop"
                  >
                    Financiamento de veículos
                  </a>
                </div>
                <div>
                  <a
                    href={`${importPrefix}financiamento-de-motos.html`}
                    id="financiamento-de-motos-menu-desktop"
                  >
                    Financiamento de motos
                  </a>
                </div>
                <div>
                  <a
                    href={`${importPrefix}financiamento-entre-particulares.html`}
                    id="financiamento-entre-particulares-menu-desktop"
                  >
                    Financiar veículo particular
                  </a>
                </div>
              </div>

              <div className="menu-col">
                <p>&nbsp;</p>
                <div>
                  <a
                    href={`${importPrefix}financiar-veiculos-eletricos.html`}
                    id="veiculos-eletricos-menu-desktop"
                  >
                    Veículos elétricos
                  </a>
                  {/* <div className="flag-destaque">Até 25% OFF</div> */}
                </div>
                <div>
                  <a
                    href={`${importPrefix}energia-solar-fotovoltaica.html`}
                    id="energia-solar-menu-desktop"
                  >
                    Energia Solar
                  </a>
                </div>
                <div>
                  <a
                    href={`${importPrefix}emprestimo-garantia-carro.html`}
                    id="emprestimo-com-garantia-de-veiculo-menu-desktop"
                  >
                    Empréstimo com Garantia de Veículo
                  </a>
                </div>
                <div>
                  <a
                    href={`${importPrefix}parcelamento-bens-servicos.html`}
                    id="parcelamento-de-bens-e-servicos-menu-desktop"
                  >
                    Parcelamento de bens e serviços
                  </a>
                </div>
              </div>

              <div className="menu-col">
                <p>&nbsp;</p>
                <div>
                  <a
                    href={`${importPrefix}seguro-santander-auto.html`}
                    id="seguro-santander-auto-menu-desktop"
                  >
                    Seguros Santander
                  </a>
                </div>
                <div>
                  <a
                    href={`${importPrefix}leilao-de-veiculos.html`}
                    id="leilao-de-veiculos-menu-desktop"
                  >
                    Leilão de veículos
                  </a>
                </div>
                <div>
                  <a href={`${importPrefix}car10.html`} id="servicos-automotivos-menu-desktop">
                    Serviços Automotivos
                  </a>
                </div>
              </div>
            </Container>
          </div>
        </li>
        <li>
          <a href={`${importPrefix}open-finance.html`} id="open-finance-menu-desktop">
            Open Finance
          </a>
        </li>
        <li>
          <a href={`${importPrefix}credenciados.html`} id="lojas-credenciadas-menu-desktop">
            Lojas Credenciadas
          </a>
        </li>
        <li>
          <a href={`${importPrefix}blog.html`} id="blog-menu-desktop">
            Blog
          </a>
        </li>
        <li>
          <span
            role="button"
            onClick={(ev) => {
              ev.preventDefault();
              updateOpenState(2);
            }}
          >
            Ajuda
          </span>
          <div role="dialog" className={getDialogClass(2)} aria-label="Menu ajuda">
            <Container className="content-container">
              <div className="menu-col">
                <p>Ajuda</p>
                <div>
                  <a
                    href={`${importPrefix}canais-de-atendimento.html`}
                    id="dentral-de-atendimento-menu-desktop"
                  >
                    Canais de atendimento
                  </a>
                </div>
                <div>
                  <a
                    href={`${importPrefix}duvidas-frequentes.html`}
                    id="duvidas-frequentes-menu-desktop"
                  >
                    Dúvidas frequentes
                  </a>
                </div>
                <div>
                  <a href={`${importPrefix}denuncias-e-fraudes.html`} id="fraudes-menu-desktop">
                    Fraudes
                  </a>
                </div>

                <div>
                  <a
                    href={`${importPrefix}politica-de-privacidade.html`}
                    id="privacidade-e-seguranca-menu-desktop"
                  >
                    Privacidade e segurança
                  </a>
                </div>
              </div>

              <div className="menu-col">
                <p>&nbsp;</p>
                <div>
                  <a
                    href="https://www.santander.com.br/educacao-financeira"
                    target="_blank"
                    rel="noopener"
                    id="orientacao-financeira-menu-desktop"
                  >
                    Orientação financeira
                  </a>
                </div>
              </div>
            </Container>
          </div>
        </li>
      </Container>
    </nav>
  );

  return (
    <>
      {enableDismiss && (
        <div
          className="dismiss-menu"
          onClick={(ev) => {
            ev.preventDefault();
            setOpen(null);
          }}
        />
      )}
      <section id="santander-menu">
        {isAmp && (
          <amp-mega-menu height="60" layout="fixed-height" class="mega-menu">
            {MenuContent}
          </amp-mega-menu>
        )}

        {!isAmp && <div className="mega-menu-ampless">{MenuContent}</div>}
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

Menu.defaultProps = {
  importPrefix: '',
};

export default Menu;
